import { useState, useRef, useEffect } from "react";
import { TextField } from "@mui/material";
import { amountExtendedRoundOff } from "helpers/NumberFormatHelper";
import { KEYBOARD_KEYS } from "const";

/**
 * A number input that keeps a local draft while typing and only commits onBlur / Enter.
 * This prevents the controlled value from interfering with multi-digit entry.
 */
function EditableTextField({ externalValue, onCommit, onClick, sx }) {
  const [localValue, setLocalValue] = useState(String(amountExtendedRoundOff(externalValue)));
  const isFocused = useRef(false);

  // Sync display value when externalValue changes from outside (e.g. qty change recalculates rate)
  useEffect(() => {
    if (!isFocused.current) {
      setLocalValue(String(amountExtendedRoundOff(externalValue)));
    }
  }, [externalValue]);

  return (
    <TextField
      type="number"
      variant="standard"
      InputProps={{ disableUnderline: true }}
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onFocus={(e) => {
        isFocused.current = true;
        e.target.select();
      }}
      onBlur={() => {
        isFocused.current = false;
        const committed = Number(localValue);
        setLocalValue(String(amountExtendedRoundOff(committed)));
        onCommit(committed);
      }}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === KEYBOARD_KEYS.ENTER) e.target.blur();
      }}
      sx={sx}
    />
  );
}

export default EditableTextField;
